<template>
  <section>    
    <v-card elevation="0">
      <v-card-title class="app-card-title">
        <h4 class="text">
          Funcionalidades
        </h4>
      </v-card-title>
      <v-card-text class="app-card-content">          
        <v-form
          ref="form"
          lazy-validation
          @submit.prevent="onSubmit"
        >
          <v-autocomplete
            v-model="functionality.selected"  
            :items="functionality.items"
            :rules="[rules.required]"
            :loading="functionality.isLoading"
            label="Funcionalidade *"
            item-text="name"
            color="success"
            return-object
            outlined
            dense            
          />
          
          <v-btn
            small
            depressed
            color="success"
            type="submit"
            :disabled="functionality.isLoading"
          >
            Adicionar
          </v-btn>         
        </v-form>
      </v-card-text>      
    </v-card>
  </section>
</template>

<script>
  import PerfisService from '@/services/perfis.service';
  import FuncionalidadesService from '@/services/funcionalidades.service';

  export default {
    name: 'ProfileFunctionalityForm',

    props: {
      profileId: {
        type: Number,
        required: true,
      },
    },
  
    data: () => ({
      functionality: {
        selected: null,
        items: [],
        isLoading: false,
      },

      paginate: {
        page: 1,
        perPage: 1000,
      }, 
      
      rules: {
        required: value => !!value || 'Esse campo deve ser preenchido'
      },
    }),

    mounted() {
      this.fetchFunctionalities();
    },

    methods: {    
      fetchFunctionalities() {
        this.functionality.isLoading = true;
        FuncionalidadesService
          .list(this.buildParams())
          .subscribe(({items, totalItems }) => {
            this.functionality.items = items;        
            this.functionality.isLoading = false;
          }, () => {
            this.functionality.isLoading = false;
          });
      },

      buildParams() { 
        const { page, perPage } = this.paginate;

        return {
          page,
          per_page: perPage,
          sort: 'id:desc'
        };
      },

      onSubmit(){
        if (!this.$refs.form.validate()) return;

        this.functionality.isLoading = true;

        PerfisService
          .addFunctionality(this.profileId, this.functionality.selected.id)
          .subscribe(() => {
            this.$refs.form.reset();
            this.functionality.selected = null;
            this.functionality.isLoading = false;            
            this.$emit('added');
          }, () => {
            this.functionality.isLoading = false;
          });
      }
    }
  }
</script>